import gsap from '@lib/gsap'


export async function introAnimation() {
  return new Promise<void>((resolve) => {

    gsap.to('.loader_wrap', {
      autoAlpha: 0,
      duration: 0.1,
      onComplete() {
        resolve()
      }
    })

  });
}


export async function outAnim() {
  return new Promise<void>((resolve) => {
    gsap.fromTo('.loader_wrap', {
      autoAlpha: 0
    }, {
      autoAlpha: 1,
      duration: 0.3,
      onComplete() {
        resolve()
      }
    })

  })
}


export async function inAnim() {
  return new Promise<void>((resolve) => {
    gsap.fromTo('.loader_wrap', {
      autoAlpha: 1,
    }, {
      autoAlpha: 0,
      duration: 0.3,
      onUpdate() {
        if (this.progress() > 0.4) {
          resolve()
        }
      }
    })

  })
}

